import gql from "graphql-tag";

export default gql`
  query getAurora($query: String!) {
    getAurora(query: $query)
  }
`;
